export default __webpack_public_path__ + "static/media/orders.6c37abc9.svg";